export { billingListScreen, billingDetailScreen } from './billing.screen';
export { billingSearch } from './billing.search';
export { loadBillingMessages } from './billing.catalog';
export const loadBillingScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBillingGuides = () => import('./billing.guide');
